/**
 * The last failed READ, shared across the app.
 *
 * Every list page asked react-query for `{ data, isLoading }` and nothing else,
 * so a failed read rendered as an empty catalogue: a 403 from the API — "missing
 * capability: catalog:read" — looked exactly like "no brands match this filter".
 * That is the worst possible confusion, because the two have opposite causes and
 * opposite fixes.
 *
 * The interception lives at the QueryClient (see main.tsx) rather than in the 24
 * pages that would each have to remember: one place, and pages written later
 * inherit it.
 *
 * A successful read clears it — if anything loaded, we are not blocked.
 */
type Listener = () => void

let message = ''
const listeners = new Set<Listener>()

export function setLoadError(next: string) {
  if (next === message) return
  message = next
  listeners.forEach((l) => l())
}

export function clearLoadError() {
  setLoadError('')
}

export function getLoadError() {
  return message
}

export function subscribeLoadError(listener: Listener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
